import * as React from 'react';
import { withRouter } from 'react-router';
import { getI18n } from 'react-i18next';
import { Responsive } from 'semantic-ui-react';
import { store } from 'pages/app/store';
import { Props, LinkProps, propTypes } from './props';
import { User } from 'types/user';
import { translations } from 'types/translations';

import './styles.css';

class LinkCellRenderer extends React.Component<Props> {
  static propTypes = propTypes;

  render() {
    const i18n = getI18n();
    const user = this.props.data as User;

    return (
      <>
        <Responsive {...Responsive.onlyMobile}>
          <div className="fullname-cell-details fullname-cell" data-id={user.id} data-username={user.username}>
            <span>
              <span className="title">{i18n.t(translations.FirstName)}:</span>
              <a style={{ cursor: 'pointer' }}
                onClick={this.callback}
                className="fullname-cell"
              >
                &nbsp;{user.firstName}
              </a>
            </span>
            <span>
              <span className="title">{i18n.t(translations.LastName)}:</span>
              <a style={{ cursor: 'pointer' }}
                onClick={this.callback}
                className="fullname-cell"
              >
                &nbsp;{user.lastName}
              </a>
            </span>
            <span><span className="title">{i18n.t(translations.Role)}:</span>&nbsp;{user.roleLabel}</span>
          </div>
        </Responsive>
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <a style={{ cursor: 'pointer' }}
            onClick={this.callback}
            className="fullname-cell"
            data-id={user.id}
            data-username={user.username}
          >
            <div className="fullname-cell-details" >
              <span>{user.firstName}</span>
              <span>{user.lastName}</span>
            </div>
          </a>
        </Responsive>
      </>
    );
  }

  private callback = () => {
    const linkProps = this.props.colDef.cellRendererParams as LinkProps;
    const user = this.props.data as User;
    const currentUserId = store.getState().userProfile.user.id;

    linkProps.callback(user.id);
    if (this.props.history) {
      if (currentUserId === user.id) {
        this.props.history.push('/user/profile');
      } else {
        this.props.history.push('/user/edit', {
          value: user.id
        });
      }
    }
  }
}

export default withRouter(LinkCellRenderer);


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/renderers/link/component.tsx